import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';

import { each, filter, has } from 'lodash';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-search-popover',
  templateUrl: './search-popover.component.html',
  styleUrls: ['./search-popover.component.scss'],
  standalone: false,
})
export class SearchPopoverComponent implements OnInit, OnChanges {
  @Input() items;
  @Input() isLoading;
  @Input() textKey;
  @Input() checkedKey;
  @Input() emptyItemsMessage;
  @Input() mode;
  @Output() onClose = new EventEmitter<any>();

  public searchText: string;
  public isShowOnlyChecked: boolean;
  public isAllChecked: boolean;
  public countSelectedItems: number;
  public singleSelectedItem: any;

  constructor() {}

  ngOnInit() {
    this.isAllChecked = false;
    this.isShowOnlyChecked = false;
    this.countSelectedItems = filter(this.items, (i) => i[this.checkedKey]).length;
    this.mode = this.mode || 'multiple';
  }

  ngOnChanges(changes: SimpleChanges) {
    if (has(changes, 'items.currentValue')) {
      this.countSelectedItems = filter(this.items, (i) => i[this.checkedKey]).length;
    }
  }

  toggleWithSearch(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
      this.checkAllChecked();
    }
  }

  checkAllChecked() {
    const checkedItems = filter(this.items, (i) => i[this.checkedKey]);
    this.isAllChecked = checkedItems.length === this.items.length;
  }

  searchPopoverHideCell() {
    this.countSelectedItems = filter(this.items, (i) => i[this.checkedKey]).length;
    this.onClose.emit();
  }

  onChangeAllChecked(event) {
    const isChecked = event.target.checked;
    each(this.items, (item) => {
      item[this.checkedKey] = isChecked;
    });
  }

  onChangeShowOnlyChecked(event) {
    this.isShowOnlyChecked = event.target.checked;
  }

  onChangeItem(event, item) {
    item[this.checkedKey] = event.target.checked;

    this.checkAllChecked();
  }

  onChangeSingleItem(item) {
    this.singleSelectedItem = item[this.textKey];
    each(this.items, (i) => {
      i.is_checked = this.singleSelectedItem === i[this.textKey];
    });
  }
}
